// @flow
import React from 'react'
import I18n from 'i18n-react'

// components
import ColumnTypeName from './_quoteComponents/ColumnTypeName'

// types
import type QuoteInstance from '../Controllers/QuoteInstance'
import type { InsuranceCompaniesType } from '../Types/InsuranceCompanyTypes'

type QuoteProps = {
  insuranceCompanies: InsuranceCompaniesType,
  quote: QuoteInstance,
  webType: number,
}

type QuoteState = {
  collapsed: boolean,
  showHelp: boolean,
  additionalShowHelp: boolean,
}

export default class Quote extends React.Component<QuoteProps, QuoteState> {
  static defaultProps = {
    content: null,
    debug: false,
    inputHelps: {},
    showPriceWithCoverages: false,
    specification: null,
    templateVariables: {},
    showPerUnitOfQuality: true,
  }

  state = {
    collapsed: true,
    showHelp: false,
    additionalShowHelp: false,
  }

  render() {
    const { quote, insuranceCompanies, webType } = this.props
    const invalidByKeys = []
    Object.values(quote.invalidBecause || {}).forEach((invalidObject) => {
      const translated = I18n.translate(`invalidQuotes.errors.${invalidObject.key}`, { notFound: invalidObject.key })
      if (!invalidByKeys.includes(translated)) {
        invalidByKeys.push(translated)
      }
    })
    return [
      <tr className="d-block d-lg-table-row border-top" key={quote.id}>
        <td className="align-left border-0 border-bottom-0 border-lg-top align-items-center py-3 pl-3 py-lg-2 pr-xl-5">
          <ColumnTypeName
            columnConfig={{}}
            data={{
              ...quote.getIn(['tariffContent', 'tpl'], {}),
              help: '',
            }}
            insuranceCompanies={insuranceCompanies}
            quote={quote}
            webType={webType}
          />
        </td>
        <td className="text-danger align-center border-0 border-bottom-0 border-lg-top align-items-center py-3 pl-3 py-lg-2 pr-xl-5">
          {invalidByKeys}
        </td>
      </tr>,
    ]
  }
}
